// Validacao e mascara de CPF/CNPJ (PT-BR)
export const CPF_INVALID_MSG = "CPF inválido. Verifique os números informados.";
export const CNPJ_INVALID_MSG = "CNPJ inválido. Verifique os números informados.";

// Mascara 000.000.000-00 progressiva
export function maskCpf(value) {
  const d = (value || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

// Validacao por digitos verificadores (modulo 11) + bloqueio de CPFs repetidos
export function isValidCpf(value) {
  const d = (value || "").replace(/\D/g, "");
  if (d.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(d)) return false; // 111.111.111-11, 222... etc

  let t = 0;
  for (let i = 0; i < 9; i++) t += parseInt(d[i], 10) * (10 - i);
  let r = (t * 10) % 11;
  if (r === 10) r = 0;
  if (r !== parseInt(d[9], 10)) return false;

  t = 0;
  for (let i = 0; i < 10; i++) t += parseInt(d[i], 10) * (11 - i);
  r = (t * 10) % 11;
  if (r === 10) r = 0;
  if (r !== parseInt(d[10], 10)) return false;

  return true;
}

// Mascara dinamica CPF (<=11) ou CNPJ (>11)
export function maskCpfCnpj(value) {
  const d = (value || "").replace(/\D/g, "").slice(0, 14);
  if (d.length <= 11) return maskCpf(d);
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}

export function isValidCnpj(value) {
  const d = (value || "").replace(/\D/g, "");
  if (d.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(d)) return false;

  const dv = (nums, weights) => {
    const s = nums.reduce((acc, n, i) => acc + parseInt(n, 10) * weights[i], 0);
    const r = s % 11;
    return r < 2 ? 0 : 11 - r;
  };
  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const w2 = [6, ...w1];
  if (dv(d.slice(0, 12).split(""), w1) !== parseInt(d[12], 10)) return false;
  if (dv(d.slice(0, 13).split(""), w2) !== parseInt(d[13], 10)) return false;
  return true;
}

// Valida CPF (11) ou CNPJ (14). Retorna {ok, isCnpj}
export function validateCpfCnpj(value) {
  const d = (value || "").replace(/\D/g, "");
  if (d.length === 14) return { ok: isValidCnpj(d), isCnpj: true };
  return { ok: isValidCpf(d), isCnpj: false };
}
